import { useEffect, useState } from 'react';

const useErrorParser = (errorResponse: any, labels: any = {}) => {
  const [parsedErrorMessage, setParsedErrorMessage] = useState('An error has occurred.');

  useEffect(() => {
    if (errorResponse) {
      const { status } = errorResponse?.response;
      if (status) {
        Object.keys(labels).forEach((labelKey) => {
          if (labelKey.includes(`error-${status}`) || labelKey.includes(`error_${status}`)) {
            setParsedErrorMessage(labels[labelKey]);
          }
        });
      }
    }
  }, [errorResponse, setParsedErrorMessage, labels]);

  return {
    parsedErrorMessage,
  };
};

export default useErrorParser;
